import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, DNAButtonProps, colors } from '@alucio/lux-ui';
import { CommonIcon } from 'src/components/DNA';
import { ContentVariant } from 'src/components/DNA/types';
import { useAppSettings } from 'src/state/context/AppSettings';

export interface PinButtonProps {
  onPin?: () => void,
  isHidden?: boolean,
  isPinned?: boolean,
  variant?: ContentVariant,
  interactive?: boolean
}

const S = StyleSheet.create({
  hidden: { display: 'none' },
})

type VariantPinStyles = Record<ContentVariant, Exclude<DNAButtonProps['status'], 'transparent'>>
const variantPinStyles: VariantPinStyles = {
  default: 'primary',
  dashboard: 'secondary',
  search: 'secondary',
  virtual: 'primary',
  customDeck: 'secondary',
  publisher: 'secondary',
  meetings: 'subtle',
  fileDrawer: 'secondary',
  dashboardFavorites: 'secondary',
}

export const PinButton: React.FC<PinButtonProps> = (props) => {
  const { onPin, isHidden, variant = 'default', interactive = true, isPinned } = props;
  const { deviceMode } = useAppSettings();
  const isDesktop: boolean = deviceMode === 'desktop';
  const size = isDesktop ? 'md' : 'xl';

  return (
    <DNABox style={isDesktop ? { minWidth: 34 } : { minWidth: 48 }}>
      {interactive
        ? <DNAButton
            testID="ghost-icon-pin"
            appearance="ghost"
            status={isPinned ? variantPinStyles[variant] : 'subtle'}
            size={size}
            iconLeft={isPinned ? 'star-fill' : 'star'}
            onPress={onPin}
            style={isHidden && S.hidden}
        />
        : <CommonIcon
            // [UI2-TODO] - Not ideal, but this should support colorMode better
            color={variant === 'virtual' ? colors['color-ui2-brand-500'] : undefined}
            variant={isPinned ? 'folder-row-pin-fill' : 'folder-row-pin'}
            status={variantPinStyles[variant]}
            size={size}
            style={isHidden && S.hidden}
        />
      }
    </DNABox>
  )
}

export default PinButton
